import { render, staticRenderFns } from "./GreyTabs.vue?vue&type=template&id=7b6d4e31&scoped=true&"
import script from "./GreyTabs.vue?vue&type=script&lang=js&"
export * from "./GreyTabs.vue?vue&type=script&lang=js&"
import style0 from "./GreyTabs.vue?vue&type=style&index=0&id=7b6d4e31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d4e31",
  null
  
)

export default component.exports